import { appConfig } from '../config'

export const theme = appConfig.theme
export const supportEmail = appConfig.salesContactEmail
export const noticeDays = appConfig.budgetLowNoticeDays
export const showSummary = appConfig.showSummary
